import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { logError } from "@/lib/log";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Suppress harmless ResizeObserver loop warning from Radix portals
if (typeof window !== "undefined") {
  const NativeResizeObserver = window.ResizeObserver;
  if (NativeResizeObserver) {
    window.ResizeObserver = class DeferredResizeObserver extends NativeResizeObserver {
      constructor(callback) {
        super((entries, observer) => window.requestAnimationFrame(() => callback(entries, observer)));
      }
    };
  }
  const ignore = (e) => {
    if (typeof e?.message === "string" && e.message.includes("ResizeObserver loop")) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  };
  window.addEventListener("error", ignore, true);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the service worker so the app installs as a PWA (Add to Home Screen / install prompt)
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((e) => logError("Service worker registration failed:", e));
  });
}
